import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { PageHeader, DataTable, StatusPill, Section, Loading, KPITile } from "../components/Common";

export default function Behaviour() {
  const [items, setItems] = useState(null);
  const [students, setStudents] = useState([]);
  useEffect(() => {
    api.behaviourIncidents().then(({ data }) => setItems(data));
    api.students().then(({ data }) => setStudents(data));
  }, []);
  const stuMap = Object.fromEntries(students.map((s) => [s.id, s]));
  if (items === null) return <Loading />;
  const cat = items.reduce((a, i) => { a[i.category] = (a[i.category] || 0) + 1; return a; }, {});
  return (
    <div data-testid="behaviour-page">
      <PageHeader kicker="Behaviour & Discipline" title="Behavioural signals" subtitle="Positive commendations and disciplinary incidents." />
      <div className="grid grid-cols-3 gap-4 mb-6">
        <KPITile testId="beh-positive" label="Positive" value={cat.positive || 0} />
        <KPITile testId="beh-minor" label="Minor" value={cat.minor || 0} />
        <KPITile tone="dark" testId="beh-major" label="Major" value={cat.major || 0} />
      </div>
      <Section>
        <DataTable
          columns={[
            { key: "date", label: "Date" },
            { key: "student", label: "Student", render: (r) => {
              const s = stuMap[r.student_id];
              return s ? `${s.first_name} ${s.last_name}` : "—";
            } },
            { key: "category", label: "Category", render: (r) => <StatusPill status={r.category} /> },
            { key: "description", label: "Description" },
            { key: "action_taken", label: "Action" },
            { key: "resolved", label: "Resolved", render: (r) => r.resolved ? <StatusPill status="resolved" /> : <StatusPill status="active" /> },
          ]}
          rows={items}
        />
      </Section>
    </div>
  );
}
